import React from 'react';
import PropTypes from 'prop-types';
import { makeStyles } from '@material-ui/styles';
import useNavigateToQuickAllocation from '~/modules/resource-management/ResourceManagementDashboard/components/ResourceManagementDashboardOverview/hooks/useNavigateToQuickAllocation';
import { ResourceUserAvailabilityGroupType } from '~/types';
import {
  GroupField,
  RoleField
} from '~/modules/resource-management/ResourcingOverview/components/ResourceAvailabilityCard/components/AvailabilityTable/hooks/columnRenders';

const useGroupLabelStyles = makeStyles(theme => ({
  name: {
    fontSize: theme.typography.body2.fontSize,
    color: theme.palette.text.main,
    textDecoration: 'none',
    [theme.breakpoints.down('xs')]: {
      fontSize: theme.typography.caption.fontSize
    },
    wordBreak: 'break-word',
    wordWrap: 'break-word',
    whiteSpace: 'pre-wrap'
  },
  noValue: {
    paddingLeft: theme.spacing(0),
    fontSize: theme.typography.body2.fontSize,
    color: theme.palette.text.secondary,
    fontStyle: 'italic',
    [theme.breakpoints.down('xs')]: {
      fontSize: theme.typography.caption.fontSize
    }
  }
}));

const useRoleLabelStyles = makeStyles(theme => ({
  roleName: {
    fontSize: theme.typography.body2.fontSize,
    [theme.breakpoints.down('xs')]: {
      fontSize: theme.typography.caption.fontSize
    },
    wordBreak: 'normal'
  },
  noValue: {
    paddingLeft: theme.spacing(0),
    fontSize: theme.typography.body2.fontSize,
    color: theme.palette.text.secondary,
    fontStyle: 'italic',
    [theme.breakpoints.down('xs')]: {
      fontSize: theme.typography.caption.fontSize
    }
  }
}));

export const GroupByColumnLabel = ({
  column: { groupBy, isClickable },
  record
}) => {
  const groupLabelClasses = useGroupLabelStyles();
  const roleLabelClasses = useRoleLabelStyles();
  const navigateToQuickAllocation = useNavigateToQuickAllocation({ groupBy });

  return groupBy === ResourceUserAvailabilityGroupType.Role ? (
    <RoleField
      classes={roleLabelClasses}
      record={record}
      onClick={navigateToQuickAllocation}
      isDisabled={!isClickable}
    />
  ) : (
    <GroupField
      classes={groupLabelClasses}
      record={record}
      groupBy={groupBy}
      onClick={navigateToQuickAllocation}
      isDisabled={!isClickable}
    />
  );
};

GroupByColumnLabel.propTypes = {
  column: PropTypes.shape({
    groupBy: PropTypes.oneOf([
      ResourceUserAvailabilityGroupType.Role,
      ResourceUserAvailabilityGroupType.Location,
      ResourceUserAvailabilityGroupType.Division,
      ResourceUserAvailabilityGroupType.ServiceCenter,
      ResourceUserAvailabilityGroupType.CostCenter,
      ResourceUserAvailabilityGroupType.Department,
      ResourceUserAvailabilityGroupType.EmployeeType
    ]).isRequired,
    isClickable: PropTypes.bool.isRequired
  }),
  record: PropTypes.object
};

export default GroupByColumnLabel;
